const BASE_API = process.env.REACT_APP_ROUTE_API;

const getHeaders = () => {
  const token = localStorage.getItem('token');

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(token && {
      Authorization: `Bearer ${token}`,
    }),
  };
};

const processarResposta = async (response) => {
  let json = {};

  try {
    json = await response.json();
  } catch (error) {
    json = {};
  }

  json.statusRetorno = response.status;

  return json;
};

export default {
  listarPorUserId: async (userId) => {
    try {
      const response = await fetch(
        `${BASE_API}site/pedidos/pedidos-por-usuario/${userId}`,
        {
          method: 'GET',
          headers: getHeaders(),
        }
      );

      const json = await processarResposta(response);

      json.data = json.data ?? [];

      return json;
    } catch (error) {
      return {
        status: 'error',
        message: 'Não foi possível carregar os pedidos.',
        data: [],
        error,
      };
    }
  },

  cancelarPedido: async (pedidoId, motivo) => {
    try {
      const response = await fetch(
        `${BASE_API}financeiro/pedidos/${pedidoId}/cancelar`,
        {
          method: 'POST',
          headers: getHeaders(),
          body: JSON.stringify({
            motivo,
          }),
        }
      );

      return await processarResposta(response);
    } catch (error) {
      return {
        status: 'error',
        message: 'Não foi possível cancelar o boleto.',
        error,
      };
    }
  },

  reemitirPedido: async (pedidoId) => {
    try {
      const response = await fetch(
        `${BASE_API}financeiro/pedidos/${pedidoId}/reemitir`,
        {
          method: 'POST',
          headers: getHeaders(),
        }
      );

      return await processarResposta(response);
    } catch (error) {
      return {
        status: 'error',
        message: 'Não foi possível reemitir o boleto.',
        error,
      };
    }
  },
};